import React, { useState } from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"

const Subscribe = () => {
  const [email, setEmail] = useState("")
  const [mensaje, setMensaje] = useState("Subscribe to us")
  const [error, setError] = useState("")

  const emailSubscribe = e => {
    setEmail({ [`${e.target.name}`]: e.target.value })
  }

  const handleSubmit = e => {
    e.preventDefault()
    addToMailchimp(email.email)
      .then(({ msg, result }) => {
        if (result !== "success") {
          setMensaje("oops, there was a problem")
          throw msg
        }
        setError("")
        setMensaje(msg)
        console.log(mensaje)
        setEmail({ email: "" })  
      })
      .catch(err => {
        console.log(err)
        setError(err)
      })
      .finally(setEmail({ email: "" }))
  }

  return (
    <div>
      <h4 className="text-2xl mb-4 font-semibold">{mensaje}</h4>
      <form className="flex" onSubmit={handleSubmit}>
        <input
          className="border focus:outline-none shadow-lg py-2 px-4 rounded-l-lg w-2/4 md:w-4/6 dark:bg-primary dark:text-white dark:border-gray-700 text-secondary"
          placeholder="your mail here"
          type="email"
          name="email"
          value={email.email}
          onChange={emailSubscribe}
          required
        />
        <button
          className="text-white shadow-lg bg-primary hover:bg-secondary hover:text-variant font-semibold py-2 px-4 rounded-r-lg transition duration-300 ease-in-out dark:bg-secondary dark:hover:bg-neutral dark:hover:text-primary"
          type="submit"
        >
          Suscribe
        </button>      
      </form>
      <p className="block pt-2 text-xs text-secondary" dangerouslySetInnerHTML={{ __html: error }} />
    </div>
  )
}

export default Subscribe
